<section class="titleBarBg fixed-top">
    <div class="container-fluid">
        <div class="row mar-7px">
            <div class="w-3">
                <img src="assets/images/tickMark.svg" class="pageIcon" alt="">
            </div>
            <div class="w-97">
                <div class="pageHeadingBar">
                    <div class="row">
                        <div class="col-md-6 align-self-center">
                            <h6 class="pageHeadingText mb-0 text-uppercase">{{headerTitle}}</h6>
                        </div>
                        <div class="col-md-6 text-end align-self-center" *ngIf="this.currentPage !== 'Dashboard'">
                            <!-- <span style="font-weight: bold; font-size: 14px; color: green; padding: 5px;">
                                Verified Images: <span style="color: #4CAF50;">{{verifiedImages}}</span>
                            </span>
                            <span style="font-weight: bold; font-size: 14px; color: red; padding: 5px;">
                                Pending Images: <span style="color: #F44336;">{{outstandingImages}}</span>
                            </span> &nbsp;&nbsp; -->
                            <span style="font-weight: bold; font-size: 14px; color: green; padding: 5px;">
                                Reviewed Stores: <span style="color: #4CAF50;">{{reviewedStores}}</span>
                            </span>
                            <span style="font-weight: bold; font-size: 14px; color: red; padding: 5px;">
                                Pending Stores: <span style="color: #F44336;">{{pendingStores}}</span>
                            </span> &nbsp;&nbsp;
                            <a style="cursor: pointer;">
                                <img src="assets/images/download_kkk.png" class="w-27px" alt=""
                                    [class.disabled]="isInputValidationSummaryLoaded"
                                    (click)="!isInputValidationSummaryLoaded && generateValidationSummaryReport()"
                                    [title]="!isInputValidationSummaryLoaded ? 'Download Validation Summary Report' : 'Report not ready yet'" />
                                &nbsp;&nbsp;
                            </a>
                            <img *ngIf="isInputValidationSummaryLoaded" src="assets/images/loader_btn.gif"
                                class="buttonsmallIcon mr-2" alt="Loader">&nbsp;&nbsp;
                            <button class="btn progressBtn ps-2 me-1" role="button" (click)="updateVerificationStatus()"
                                [disabled]="projectStatus == 'Verified'" [ngStyle]="{'pointer-events' :   projectStatus == 'Verified' ? 'none':'auto',
                                            'opacity' : projectStatus == 'Verified' ? '0.5':'1' }">
                                <div class="d-flex">
                                    <div>
                                        <img src="assets/images/green_tickmark.svg" class="btnrefreshIcon" alt="">
                                    </div>
                                    <div>
                                        COMPLETE VERIFICATION
                                    </div>
                                </div>
                            </button>
                        </div>
                        <!-- <div class="col-md-3 align-self-center">
                        </div>
                        <div class="col-md-3 align-self-center text-end">
                            <ul class="list-inline mb-0">
                                <li class="list-inline-item" style="cursor:pointer">
                                    <a (click)="navigateToPage()">
                                        <img [src]="imgURLforGalleryOrCard" class="me-2 w-25px" alt="" [title]="imgTitle">
                                    </a>
                                </li>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>